import * as angular from "angular";
import {IController, IFilterService} from "angular";
import * as _ from "lodash"
import {VehicleType} from "../../../commons/types/vehicle.type";
import {TaskModel} from "../../../tasks/models/task.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {TaskType} from "../../../tasks/types/task.type";
import {TaskStatusType} from "../../../tasks/types/taskStatus.type";
import {IAMPermissionsService} from "../../../../permission/iamPermissions.service";

export class PlanningRouteTasksTableRowCtrl implements IController {

  planningRouteTasksTableCtrl: IController;
  task: TaskModel;
  taskAnalysis: any;
  index: any;
  isHighlighted: any;
  hasForcedStartOption: any;
  isForcedStart: any;
  isForcedStartDisabled: any;
  hasForcedEndOption: any;
  isForcedEnd: any;
  isForcedEndDisabled: any;
  isBundle: any;
  isEditable: any;
  selectedKeys: any;
  toggle: Function;
  onForcedStartToggle: Function;
  onForcedEndToggle: Function;

  public purposeToServiceType: any;
  public configZoneId: undefined;
  public bindingSubTask: any;
  public logisticsVehiclesRefList: any[];
  public omsOrderIds: string[];
  public bundleServiceIds: string[];
  public bundleWeight: string;
  public taskType: typeof TaskType = TaskType;
  public taskStatusType : typeof TaskStatusType = TaskStatusType;
  public enableAgentVehicleBinding: boolean;

  constructor(private $task,
              private tasksConstants,
              private splitService: SplitService,
              private $filter,
              private IAMPermissions: IAMPermissionsService,
              private commonsService: CommonsService) {
    this.purposeToServiceType = this.tasksConstants.purposeToServiceType;
    this.enableAgentVehicleBinding = this.IAMPermissions.hasPermission('vehicleInstance.logisticsVehicle.update') &&
      !!this.splitService.getEnableAgentVehicleBinding();
  }

  $onInit() {
    this.configZoneId = this.splitService.getTimeZone();
    this._setRouteData();
  };

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.task && !changes.task.isFirstChange()) {
      this._setRouteData();
    }
  }

  onForcedStart() {
    const taskIds = angular.copy(this.task.taskIdList || []);

    if (this.task.taskType === 'BundledStopover') {
      taskIds.push(this.task.id);
    }

    this.onForcedStartToggle({taskIds: taskIds});
  }

  onForcedEnd() {
    const taskIds = angular.copy(this.task.taskIdList || []);

    if (this.task.taskType === 'BundledStopover') {
      taskIds.push(this.task.id);
    }
    this.onForcedEndToggle({taskIds: taskIds});
  }

  _setLogisticsVehiclesRefList(bindingSubTask) {
    this.logisticsVehiclesRefList = [];
    if (!!bindingSubTask) {
      _.forEach(bindingSubTask.actions, (ac) => {
        if (ac.type === "VehicleBinding") {
          const logisticsVehicleReference = _.get(ac, 'logisticsVehicleReference');
          _.get(logisticsVehicleReference, 'vehicleType') === VehicleType.Trailer ?
            this.logisticsVehiclesRefList.push(logisticsVehicleReference) : this.logisticsVehiclesRefList.unshift(logisticsVehicleReference)
        }
      })
    }
  }

  private _setRouteData() {
    this.bundleServiceIds = [];
    this.bundleWeight = undefined;
    this.bindingSubTask = undefined;
    if (this.task.subTasks && (this.task.taskSpec.purpose === 'StartRoute' || this.task.taskSpec.purpose === 'EndRoute')) {

      this.bindingSubTask = _.find(this.task.subTasks, (st) => {
        return _.find(st.actions, (ac) => {
          return ac.type === "VehicleBinding";
        })!!
      })

      this._setLogisticsVehiclesRefList(this.bindingSubTask);
    }

    if (this.isBundle && this.task.packageList?.length) {
      this.bundleServiceIds = _.map(this.task.bundledTaskList, (t) => {
        return t.serviceExternalId || t.serviceId;
      });
      // this.bundleServiceIds = _.flatMap(this.task.bundledTaskList, 'serviceExternalId');
      let hasAnyWeight = false;
      let totalBundleWeight: number = this.task.bundledTaskList?.reduce((sum, task) => {

        const weight = this.commonsService.getPackageWeight(task.packageList[0]);
        if (typeof weight !== "undefined") {
          hasAnyWeight = true;
        }

        sum += typeof weight === "number" ? +weight : 0;
        return sum;
      }, 0)

      this.bundleWeight = hasAnyWeight ? this.$filter('bringozWeight')(totalBundleWeight, true) : '--';
    }
  }

  private _getTasksOmsOrderIds(tasks: any) {
    const orderIds = tasks
      .filter(t => {
        return !!t.serviceInfo?.omsOrderReference
      })
      .flatMap(t => {
        return t.serviceInfo.omsOrderReference.id
      });

    //Uniq array
    return orderIds.filter((item, i, ar) => ar.indexOf(item) === i);
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRouteTasksTableRow', {
    require: {
      planningRouteTasksTableCtrl: '^planningRouteTasksTable'
    },
    bindings: {
      task: '<',
      taskAnalysis: '<',
      index: '<',
      isHighlighted: '<',
      hasForcedStartOption: '<?',
      isForcedStart: '<?',
      isForcedStartDisabled: '<?',
      hasForcedEndOption: '<?',
      isForcedEnd: '<?',
      isForcedEndDisabled: '<?',
      isBundle: '<',
      isEditable: '<?',
      selectedKeys: '<',
      toggle: '&',
      onForcedStartToggle: '&',
      onForcedEndToggle: '&'
    },
    template: require('./planning-route-tasks-table-row.html').default,
    controller: PlanningRouteTasksTableRowCtrl
  });
